// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const recordSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  schemaId: z.string().max(100),
  title: z.string().max(500),
  status: z.string().max(50).optional(),
  parentId: z.string().max(100).optional(),
  parentCollection: z.string().max(200).optional(),
  data: z.record(z.string(), z.unknown()),
  archived: z.boolean(),
  completed: z.boolean().optional(),
  completedAt: z.string().max(200).datetime().optional(),
  startedAt: z.string().max(200).datetime().optional(),
  sortOrder: z.number().int().min(0).max(999999).optional(),
  assigneeId: z.string().max(100).optional(),
  priority: z.number().int().min(0).max(4).optional(),
  dueAt: z.string().max(200).datetime().optional(),
  amount: z.number().min(-999999999).max(999999999).multipleOf(0.01).optional(),
  version: z.number().int().min(1).max(9999999),
  tenantId: z.string().max(100).optional(),
})

export type RecordInput = z.infer<typeof recordSchema>
